// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  forgetPasswordStatus: {
    data: null,
  },
  otpverifyStatus: {
    data: null,
  },
  newPasswordStatus: {
    data: null,
  },
  adminGetProfileDataStatus: {
    data: null,
  },
  adminProfileStatus: {
    data: null,
  },
  getAdminDataHomeStatus: { data: null },
};
